// F-MOTOR-RESERVAS.3.0 — mapeamento slug → label pt-BR das comodidades.
// Catálogo espelha o backend em server.py (COMODIDADES_POUSADA / COMODIDADES_QUARTO).
// Alterações estruturais devem acontecer primeiro no backend; aqui apenas rotulamos.

export const COMODIDADES_POUSADA_LABELS = {
  piscina: "Piscina",
  jacuzzi: "Jacuzzi",
  sauna: "Sauna",
  churrasqueira: "Churrasqueira",
  salao_jogos: "Salão de jogos",
  playground: "Playground",
  horta: "Horta",
  pet_friendly: "Pet friendly",
  estacionamento_coberto: "Estacionamento coberto",
  wifi_areas_comuns: "Wi-Fi nas áreas comuns",
  cafe_manha_incluso: "Café da manhã incluso",
  restaurante: "Restaurante",
  bar: "Bar",
  trilhas: "Trilhas",
  lareira: "Lareira",
  espaco_eventos: "Espaço para eventos",
  acessibilidade: "Acessibilidade",
  familia: "Para famílias",
  romantico: "Romântico",
};

export const COMODIDADES_QUARTO_LABELS = {
  wifi: "Wi-Fi",
  ar_condicionado: "Ar-condicionado",
  ventilador: "Ventilador",
  aquecedor: "Aquecedor",
  tv: "TV",
  tv_cabo: "TV a cabo",
  smart_tv: "Smart TV",
  netflix: "Netflix",
  frigobar: "Frigobar",
  cofre: "Cofre",
  secador_cabelo: "Secador de cabelo",
  banheira: "Banheira",
  box_blindex: "Box blindex",
  cama_king: "Cama king",
  cama_queen: "Cama queen",
  cama_solteiro: "Cama de solteiro",
  varanda: "Varanda",
  vista_jardim: "Vista para o jardim",
  vista_piscina: "Vista para a piscina",
  vista_natureza: "Vista para a natureza",
  escrivaninha: "Escrivaninha",
  fechadura_eletronica: "Fechadura eletrônica",
};

export function labelComodidadePousada(slug) {
  return COMODIDADES_POUSADA_LABELS[slug] || slug;
}

export function labelComodidadeQuarto(slug) {
  return COMODIDADES_QUARTO_LABELS[slug] || slug;
}
